import { render, staticRenderFns } from "./IFrameFormContent.vue?vue&type=template&id=1f0139e8"
import script from "./IFrameFormContent.vue?vue&type=script&lang=js"
export * from "./IFrameFormContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports